function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import 'assets/styles/app.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
const loadedComponents = [];
document.addEventListener('DOMContentLoaded', /*#__PURE__*/_asyncToGenerator(function* () {
  /**
   * Bootstrap the components
   */
  for (const dataComponent of document.querySelectorAll('[data-component]')) {
    let componentName = dataComponent.dataset.component;
    if (loadedComponents.indexOf(componentName) === -1) {
      loadedComponents.push(componentName);
      try {
        let component = yield import( /* WebpackMode: "lazy" */
        /* webpackPrefetch: true */
        /* webpackPreload: true */
        `components/${componentName}/${componentName}.js`);
        component.default();
      } catch (error) {
        console.error('Loading error: ', error);
      }
    }
  }
  AOS.init({
    once: true
  });
}));